import {onReady} from "../../../../modules/vegas/js/util";
import enableTooltip from "./tooltip"

onReady(enableTooltip);
typeof onTurboRender !== 'undefined' && onTurboRender(enableTooltip);

